// Entegrasyon Merkezi (FAZ6A/6B) — SAF yardımcılar: uç nokta sabitleri, güvenli normalleştirme, hata sınıflama,
// sabit kod → Türkçe metin eşlemesi ve dry-run öneri kurucusu.  Ağ, DOM, log ve telemetri YOK.
//
// Güvenlik ilkeleri
// - Sunucu yanıtı state'e girmeden önce `normalizeHub` / `normalizeImpact` ile YALNIZ izinli alanlara indirgenir
//   (beklenmeyen alanlar — kimlik, token, ham cevap vb. — hiçbir zaman state'e/DOM'a ulaşmaz).
// - Bilinmeyen sabit kodlar ham haliyle gösterilmez; genel güvenli mesaja düşer.

export const HUB_PATH = "/integration-hub";
export const IMPACT_PATH = "/integration-hub/ownership-impact";
// Telemetri DURUMA GÖRE: beklenen 4xx/429 sessiz; 503 ve ağ hataları RAPORLANIR (pilotta görülmeli).  Rapora yanıt metni/yığın/yük girmez (redact).
export const HUB_GET_CONFIG = Object.freeze({ silent_statuses: Object.freeze([401, 403, 404, 429]), redact_telemetry: true, expose_error_meta: true, no_retry: true });
export const IMPACT_POST_CONFIG = Object.freeze({ silent_statuses: Object.freeze([404, 413, 422, 429]), redact_telemetry: true, expose_error_meta: true });

// ---------------------------------------------------------------- Türkçe metinler
export const CONNECTION_STATES = {
  CONNECTED: { label: "Bağlı", tone: "ok", hint: "Yerel kayıtlara göre bağlantı etkin." },
  NOT_CONNECTED: { label: "Bağlı değil", tone: "muted", hint: "Bu sağlayıcı için bağlantı kaydı yok." },
  DISCONNECTED: { label: "Bağlantı kesildi", tone: "warn", hint: "Bağlantı daha önce kesilmiş." },
  DEGRADED: { label: "Sorunlu", tone: "warn", hint: "Kayıt okunamadı veya durum belirsiz." },
  REAUTH_REQUIRED: { label: "Yeniden yetkilendirme gerekli", tone: "danger", hint: "Bağlantıyı yeniden kurmanız gerekir." },
};

export const CAPABILITY_LABELS = {
  "connection.test": "Bağlantı testi", "outgoing.create_draft": "Giden belge taslağı", "outgoing.send": "Giden belge gönderimi",
  "outgoing.status": "Giden belge durumu", "outgoing.cancel": "Giden belge iptali", "outgoing.pdf": "Giden belge PDF",
  "outgoing.ubl": "Giden belge UBL", "outgoing.query_taxpayer": "Mükellef sorgusu", "incoming.list": "Gelen belge listesi",
  "incoming.detail": "Gelen belge detayı", "incoming.status": "Gelen belge durumu", "incoming.pdf": "Gelen belge PDF",
  "incoming.ubl": "Gelen belge UBL", "incoming.accept_reject": "Gelen belge kabul/ret", "contacts.read": "Cari okuma",
  "contacts.write": "Cari yazma", "products.read": "Ürün okuma", "products.write": "Ürün yazma", "warehouses.read": "Depo okuma",
  "inventory.read": "Stok okuma", "inventory.write": "Stok yazma", "accounts.read": "Hesap okuma", "settlements.write": "Tahsilat/ödeme yazma",
};

// Sabit sunucu kodları (kart sorunları, genel sorunlar, sahiplik sorunları, dry-run bulguları, etki kodları)
export const CODE_TEXT = {
  // kart / hub sorunları
  RECORD_INVALID: "Bu sağlayıcının kaydı beklenen biçimde değil.",
  STATUS_INVALID: "Bağlantı durumu okunamadı.",
  STATUS_UNKNOWN: "Bağlantı durumu tanınmıyor; güvenli tarafta sorunlu sayıldı.",
  PROVIDER_KEY_COLLISION: "Aynı sağlayıcı için birden fazla kayıt var; hangisinin geçerli olduğu belirlenemedi.",
  SYNC_EVIDENCE_IGNORED: "Geçersiz veya ileri tarihli bir senkron kaydı yok sayıldı.",
  SYNC_EVIDENCE_TIME_INVALID: "Bir senkron kaydının tarihi geçersiz olduğu için yok sayıldı.",
  SYNC_SOURCE_UNAVAILABLE: "Son senkron bilgisi şu anda okunamadı.",
  CARD_BUILD_FAILED: "Bu sağlayıcının kartı hazırlanamadı; diğer sağlayıcılar etkilenmedi.",
  ACCOUNTING_CONFIG_INVALID: "Ön muhasebe yapılandırması geçersiz; sahiplik görünümü gösterilemiyor.",
  OWNERSHIP_UNAVAILABLE: "Sahiplik görünümü şu anda hazırlanamadı.",
  // sahiplik sorunları
  ACCOUNTING_AND_LEDGER_OWNERS_DIFFER: "Ön muhasebe sahibi ile cari defter sahibi farklı.",
  ACCOUNTING_OWNER_NOT_CONNECTED: "Ön muhasebe sahibi olan sağlayıcının bağlantısı yok.",
  LEDGER_OWNER_NOT_CONNECTED: "Cari defter sahibi olan sağlayıcının bağlantısı yok.",
  INVENTORY_OWNER_NOT_CONNECTED: "Stok sahibi olan sağlayıcının bağlantısı yok.",
  CASH_OWNER_NOT_CONNECTED: "Kasa/banka sahibi olan sağlayıcının bağlantısı yok.",
  OUTGOING_OWNER_NOT_CONNECTED: "Giden belge sahibi olan sağlayıcının bağlantısı yok.",
  INVENTORY_PROVIDER_MISMATCH: "Stok sahibi ile stok sağlayıcısı uyuşmuyor.",
  OUTGOING_PROVIDER_MISSING: "Giden belge için sağlayıcı seçilmemiş.",
  OBIHUB_CASH_WITH_EXTERNAL_LEDGER: "Kasa ObiHub'da, cari defter dış sistemde; tahsilatlar yalnız referans olarak kalır.",
  // dry-run engelleri
  PROPOSED_CONFIG_INVALID: "Önerilen yapılandırma geçerli değil.",
  CURRENT_CONFIG_INVALID: "Mevcut yapılandırma geçerli olmadığı için karşılaştırma yapılamıyor.",
  PROVIDER_UNKNOWN: "Seçilen sağlayıcı sistemde tanımlı değil.",
  PROVIDER_CAPABILITY_MISSING: "Seçilen sağlayıcı bu alan için gereken işlemleri desteklemiyor.",
  CAPABILITY_CONTRACT_INCOMPLETE: "Bu alanın dış sistemde yönetilmesi henüz desteklenmiyor.",
  NEW_OWNER_NOT_CONNECTED: "Seçilen sağlayıcı için bağlantı referansı yok.",
  NEW_OWNER_NOT_READY: "Seçilen sağlayıcı bağlı değil veya gerekli kimlik bilgileri eksik.",
  OUTBOX_RETRY_METADATA_UNKNOWN: "Başarısız işlemlerin yeniden deneme bilgisi belirsiz kayıtlar var.",
  OUTBOX_LEASE_PRESENT: "Kilitli (yürütme için ayrılmış) işlem kaydı var.",
  RECON_APPLY_LEASE_PRESENT: "Uygulanma aşamasında kalmış mutabakat önerisi var.",
  PENDING_COUNT_UNAVAILABLE: "Bekleyen işlerin bir kısmı sayılamadı; güvenli tarafta engellendi.",
  DRAFT_LIFECYCLE_UNKNOWN: "Hazırlanmış taslaklar var ve durumları belirlenemiyor.",
  DOUBLE_RECORD_RISK: "Bekleyen işler eski sahip altında tamamlanırsa çift kayıt oluşabilir.",
  UNPROCESSABLE_RECORD_RISK: "Bekleyen işler yeni düzende işlenemeyebilir.",
  // dry-run uyarıları
  PENDING_APPROVALS_EXIST: "Onay bekleyen veya sürmekte olan işlemler var.",
  OUTBOX_WORK_OPEN: "Yürütülmeyi bekleyen işlem kayıtları var.",
  RECON_PROPOSALS_OPEN: "Açık mutabakat önerileri var.",
  COUNT_CAPPED: "Sayımlar üst sınıra ulaştı; gerçek sayı daha yüksek olabilir.",
  NEW_OWNERSHIP_ISSUE: "Yeni düzende ek bir sahiplik sorunu ortaya çıkıyor.",
  NEW_LEDGER_CASH_MISMATCH: "Yeni düzende kasa ve cari defter farklı sistemlerde.",
  // bilgi
  NO_CHANGES: "Seçilen düzen mevcut düzenle aynı; değişiklik yok.",
  NO_CURRENT_CONFIG: "Karşılaştırılacak mevcut yapılandırma yok.",
  SETTLEMENT_AND_STOCK_LEDGER_NOT_COUNTED: "Bekleyen tahsilat/ödeme ve stok hareketleri bu analize dahil değil.",
  // etki kodları
  EXISTING_RECORDS_KEPT_READ_ONLY: "Mevcut kayıtlar silinmez, salt-okunur kalır.",
  OBIHUB_STOPS_WRITING_NEW_RECORDS: "ObiHub bu alanda yeni kayıt yazmayı bırakır.",
  NEW_RECORDS_ARE_REFERENCE_ONLY: "Yeni kayıtlar yalnız referans olarak tutulur.",
  OBIHUB_BALANCES_NOT_UPDATED: "ObiHub bakiyeleri güncellenmez.",
  OBIHUB_STARTS_WRITING_RECORDS: "ObiHub bu alanda kayıt yazmaya başlar.",
  OPENING_BALANCE_SYNC_REQUIRED: "Açılış bakiyesi eşitlemesi gerekir.",
  PROVIDER_HISTORY_NOT_IMPORTED: "Sağlayıcıdaki geçmiş kayıtlar ObiHub'a aktarılmaz.",
  PROVIDER_MAPPINGS_REQUIRED: "Sağlayıcı eşleştirmeleri yeniden kurulmalı.",
  CACHE_MUST_BE_RESCOPED: "Önbellekler yeni kaynağa göre yenilenmeli.",
  DOMAIN_DISABLED: "Bu alan kapatılıyor.",
  OLD_SOURCE_DATA_NOT_SHOWN: "Eski kaynağın verileri artık gösterilmez.",
  PENDING_DOCUMENTS_STAY_WITH_OLD_PROVIDER: "Bekleyen belgeler eski sağlayıcıda kalır.",
  NUMBERING_SEQUENCE_CHANGES: "Belge numaralandırma sırası değişir.",
};
export const GENERIC_CODE_TEXT = "Bu durum için ayrıntılı açıklama bulunamadı.";

export function describeCode(code) {
  return typeof code === "string" && Object.prototype.hasOwnProperty.call(CODE_TEXT, code) ? CODE_TEXT[code] : GENERIC_CODE_TEXT;
}

export const FIELD_LABELS = {
  outgoing_source: "Giden belge sahibi", invoice_provider: "Fatura sağlayıcısı", incoming_source: "Gelen fatura kaynağı",
  inventory_owner: "Stok sahibi", accounting_owner: "Ön muhasebe sahibi", customer_ledger_owner: "Cari defter sahibi",
  cash_bank_owner: "Kasa/banka sahibi", settlement_owner: "Tahsilat/ödeme sahibi", product_catalog_owner: "Ürün kataloğu sahibi",
};
export const AUTHORITY_LABELS = { obihub: "ObiHub", disabled: "Kapalı", parasut: "Paraşüt", bizimhesap: "BizimHesap", benimpos: "BenimPOS" };
export const PROVIDER_LABELS = { parasut: "Paraşüt", bizimhesap: "BizimHesap", benimpos: "BenimPOS", "turkcell-efatura": "Turkcell e-Fatura" };

export function providerLabel(key) {
  return PROVIDER_LABELS[key] || "Bilinmeyen sağlayıcı";
}
export function ownerLabel(owner) {
  if (!owner || typeof owner !== "object") return "—";
  if (owner.authority && AUTHORITY_LABELS[owner.authority]) return AUTHORITY_LABELS[owner.authority];
  if (owner.provider) return providerLabel(owner.provider);
  return "—";
}

// ---------------------------------------------------------------- tarih
export function formatSyncTime(value) {
  if (typeof value !== "string" || !value) return "Bilinmiyor";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "Bilinmiyor";
  return new Intl.DateTimeFormat("tr-TR", { dateStyle: "medium", timeStyle: "short", timeZone: "Europe/Istanbul" }).format(d);
}

// ---------------------------------------------------------------- normalleştirme (allowlist)
// GERÇEK allowlist'ler: yalnız bu tablolarda bulunan değerler state'e girer; diğer her şey null / "UNKNOWN" olur
// (tenant benzeri beklenmeyen değerler state'e dahi ulaşmaz).
const own = (table, v) => (typeof v === "string" && Object.prototype.hasOwnProperty.call(table, v) ? v : null);
const knownCode = (v) => own(CODE_TEXT, v);
const knownProvider = (v) => own(PROVIDER_LABELS, v);
const knownAuthority = (v) => own(AUTHORITY_LABELS, v);
const codeList = (v) => (Array.isArray(v) ? Array.from(new Set(v.slice(0, 20).map((c) => knownCode(c) || "UNKNOWN"))) : []);

function normalizeOwner(o) {
  if (!o || typeof o !== "object") return null;
  return { authority: knownAuthority(o.authority), provider: knownProvider(o.provider), explicit: o.explicit === true };
}

export function normalizeHub(data) {
  if (!data || typeof data !== "object" || !Array.isArray(data.providers)) return null;
  const providers = data.providers.slice(0, 20).map((p) => {
    const q = p && typeof p === "object" ? p : {};
    const key = knownProvider(q.provider);
    return {
      provider: key,
      label: key ? providerLabel(key) : "Bilinmeyen sağlayıcı",
      capabilities: Array.isArray(q.capabilities) ? q.capabilities.filter((c) => typeof c === "string" && CAPABILITY_LABELS[c]).slice(0, 40) : [],
      connectionState: Object.prototype.hasOwnProperty.call(CONNECTION_STATES, q.connection_state) ? q.connection_state : "DEGRADED",
      hasCredentials: q.has_credentials === true,
      scopesReported: Array.isArray(q.scopes_reported) ? q.scopes_reported.filter((s) => typeof s === "string" && /^[A-Za-z0-9_.:-]{1,64}$/.test(s)).slice(0, 32) : [],
      scopesVerified: q.scopes_verified === true,
      lastSuccess: typeof q.last_sync_success_at === "string" ? q.last_sync_success_at.slice(0, 40) : null,
      lastFailure: typeof q.last_sync_failure_at === "string" ? q.last_sync_failure_at.slice(0, 40) : null,
      issues: codeList(q.issues),
    };
  });
  let ownership = null;
  if (data.ownership && typeof data.ownership === "object") {
    ownership = { fields: {}, invoiceProvider: knownProvider(data.ownership.invoice_provider), incomingSource: knownProvider(data.ownership.incoming_source), issues: codeList(data.ownership.issues) };
    for (const f of ["outgoing_source", "inventory_owner", "accounting_owner", "customer_ledger_owner", "cash_bank_owner", "settlement_owner", "product_catalog_owner"]) {
      ownership.fields[f] = normalizeOwner(data.ownership[f]);
    }
  }
  return { providers, ownership, issues: codeList(data.issues) };
}

const SEVERITIES = new Set(["blocker", "warning", "info"]);

export function normalizeImpact(data) {
  if (!data || typeof data !== "object" || !Array.isArray(data.changes) || !Array.isArray(data.findings)) return null;
  const pending = {};
  if (data.pending && typeof data.pending === "object") {
    for (const [k, v] of Object.entries(data.pending)) {
      if (!Object.prototype.hasOwnProperty.call(PENDING_LABELS, k) || !v || typeof v !== "object") continue;
      pending[k] = { count: Number.isInteger(v.count) && v.count >= 0 ? v.count : null, capped: v.capped === true };
    }
  }
  return {
    changes: data.changes.slice(0, 20).map((c) => ({
      field: typeof c?.field === "string" && FIELD_LABELS[c.field] ? c.field : null,
      before: normalizeOwner(c?.before), after: normalizeOwner(c?.after), impacts: codeList(c?.impacts),
    })).filter((c) => c.field),
    pending,
    findings: data.findings.slice(0, 50).map((f) => ({
      code: knownCode(f?.code) || "UNKNOWN",
      severity: SEVERITIES.has(f?.severity) ? f.severity : "info",
      field: typeof f?.field === "string" && FIELD_LABELS[f.field] ? f.field : null,
    })),
    riskLevel: ["LOW", "MEDIUM", "HIGH", "BLOCKING"].includes(data.risk_level) ? data.risk_level : "BLOCKING",
    canApply: data.can_apply === true,
  };
}

export const PENDING_LABELS = {
  approvals_open: "Açık onay kayıtları", prepared_stock_drafts_total: "Hazırlanmış stok taslakları (toplam, durumu belirsiz)",
  prepared_payable_drafts_total: "Hazırlanmış borç taslakları (toplam, durumu belirsiz)", outbox_open: "Yürütülmeyi bekleyen işlemler",
  outbox_retry_metadata_unknown: "Yeniden deneme bilgisi belirsiz işlemler", outbox_lease_present: "Kilitli işlemler",
  recon_open: "Açık mutabakat önerileri", recon_apply_lease_present: "Uygulanma aşamasında kalmış mutabakat önerileri",
};

export const RISK_TEXT = {
  LOW: { label: "Düşük risk", tone: "ok" }, MEDIUM: { label: "Orta risk", tone: "warn" },
  HIGH: { label: "Yüksek risk", tone: "danger" }, BLOCKING: { label: "Engelli", tone: "danger" },
};

// ---------------------------------------------------------------- hata sınıflama
// GET /integration-hub
export function classifyHubError(err) {
  const status = Number(err?.status || 0);
  if (status === 404) return { kind: "hidden" };                       // özellik kapalı: arayüz TAMAMEN görünmez
  if (status === 401 || status === 403) return { kind: "hidden" };     // oturum davranışını api katmanı yönetir
  if (status === 429) return { kind: "rate_limited", retryAfter: Number.isInteger(err?.retryAfter) ? err.retryAfter : null };
  return { kind: "unavailable" };
}

// POST /integration-hub/ownership-impact
export function describeImpactError(err) {
  const status = Number(err?.status || 0);
  if (status === 404) return "Etki analizi hesabınız için etkin değil.";
  if (status === 413) return "Gönderilen öneri çok büyük olduğu için analiz edilemedi.";
  if (status === 422) return "Seçimleriniz geçerli bir öneri oluşturmadı. Lütfen seçimleri kontrol edip tekrar deneyin.";
  if (status === 429) {
    const s = Number.isInteger(err?.retryAfter) ? err.retryAfter : null;
    return s ? `Çok fazla analiz isteği gönderildi. Lütfen ${s} saniye sonra tekrar deneyin.` : "Çok fazla analiz isteği gönderildi. Lütfen biraz bekleyip tekrar deneyin.";
  }
  if (status === 503) return "Etki analizi şu anda yapılamıyor. Lütfen daha sonra tekrar deneyin.";
  return "Etki analizi tamamlanamadı. Lütfen daha sonra tekrar deneyin.";
}

// ---------------------------------------------------------------- dry-run DEĞİŞİKLİK sözleşmesi
// İstemci TAM yapılandırma göndermez/almaz: yalnız {changes: {alan: değer}}.  Sunucu mevcut yapılandırmayı kendisi okur ve kopyaya uygular.
// settlement_owner TÜRETİLMİŞTİR; seçilemez.
export const EDITABLE_FIELDS = [
  { field: "outgoing_source", kind: "authority" }, { field: "inventory_owner", kind: "authority" },
  { field: "customer_ledger_owner", kind: "authority" }, { field: "cash_bank_owner", kind: "authority" },
  { field: "accounting_owner", kind: "authority" }, { field: "product_catalog_owner", kind: "authority" },
  { field: "incoming_source", kind: "provider" }, { field: "invoice_provider", kind: "provider" },
];
export const AUTHORITY_OPTIONS = ["obihub", "disabled", "parasut", "bizimhesap", "benimpos"];
export const PROVIDER_OPTIONS = ["parasut", "bizimhesap", "benimpos", "turkcell-efatura"];
export const UNKNOWN_CURRENT = "";   // mevcut değer bilinmiyorsa (sahiplik görünümü yok) authority seçimi bu değerden başlar

// Başlangıç değeri GÜVENLİ hub sahiplik görünümünden gelir (tam yapılandırma değil).
export function currentValue(ownership, def) {
  if (!ownership) return UNKNOWN_CURRENT;
  if (def.field === "incoming_source") return ownership.incomingSource || "";
  if (def.field === "invoice_provider") return ownership.invoiceProvider || "";
  return ownership.fields?.[def.field]?.authority || UNKNOWN_CURRENT;
}

// Yalnız DEĞİŞEN ve izinli listede olan alanlar; geçersiz değer varsa null (asla gönderilmez).
export function buildChanges(ownership, selections) {
  const out = {};
  for (const def of EDITABLE_FIELDS) {
    if (!Object.prototype.hasOwnProperty.call(selections || {}, def.field)) continue;
    const value = selections[def.field];
    if (def.kind === "authority" && value === UNKNOWN_CURRENT) continue;       // "mevcut değer bilinmiyor" yer tutucusuna dönüş = değişiklik yok
    const allowed = def.kind === "authority" ? AUTHORITY_OPTIONS : ["", ...PROVIDER_OPTIONS];
    if (typeof value !== "string" || !allowed.includes(value)) return null;
    if (value !== currentValue(ownership, def)) out[def.field] = value;
  }
  return out;
}
